/* Outdoors Nordic. Flyttad ur blocks/on-delivery-trust.liquid 2026-10-07.
   Lag inline och skickades med varje sidvisning som anvande sektionen.
   Laddas som modul: samma URL evalueras en gang oavsett antal taggar. */
(function () {
if (customElements.get('on-delivery-trust')) return;
var TZ = { SE:'Europe/Stockholm',NO:'Europe/Oslo',DK:'Europe/Copenhagen',FI:'Europe/Helsinki',DE:'Europe/Berlin',AT:'Europe/Vienna',CH:'Europe/Zurich',NL:'Europe/Amsterdam',BE:'Europe/Brussels',FR:'Europe/Paris',IT:'Europe/Rome',ES:'Europe/Madrid',PL:'Europe/Warsaw',PT:'Europe/Lisbon',GB:'Europe/London',UK:'Europe/London',CA:'America/Toronto',US:'America/New_York' };
var HLABEL = { sv:'tim',se:'tim',nb:'t',no:'t',nn:'t',da:'t',fi:'t',de:'Std',nl:'u',fr:'h',it:'h',es:'h',pl:'g',pt:'h',en:'h' };
var LOCMAP = { sv:'sv-SE',se:'sv-SE',da:'da-DK',nb:'nb-NO',no:'nb-NO',nn:'nn-NO',fi:'fi-FI',de:'de-DE',nl:'nl-NL',fr:'fr-FR',it:'it-IT',es:'es-ES',pl:'pl-PL',pt:'pt-PT',en:'en-GB' };
function pad(n){ return n < 10 ? '0' + n : '' + n; }
/* Prestanda 2026-10-15: rutan uppdateras varje sekund. Formateraren skapas en gang per
   tidszon i stallet for vid varje tick, och HTML skrivs bara nar texten faktiskt andras
   (med timmar kvar byter den bara varje minut). Samma utdata som forut. */
var FMT = {};
function fmt(tz) {
 if (!FMT[tz]) FMT[tz] = new Intl.DateTimeFormat('en-GB', { timeZone: tz, year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:false });
 return FMT[tz];
}
/* INP (omgang 52): toLocaleDateString bygger en ny formaterare vid varje anrop, och rutan
   anropade den varje sekund (30-57 ms per tick pa en lugnare mobil, matt). Formateraren
   sparas per sprak och format; Intl.DateTimeFormat#format ger samma text. */
var DFMT = {};
function dstr(d, loc, o) {
 var k = loc + '|' + JSON.stringify(o);
 if (!DFMT[k]) { try { DFMT[k] = new Intl.DateTimeFormat(loc, o); } catch (e) { return d.toLocaleDateString(loc, o); } }
 return DFMT[k].format(d);
}
/* Skriver bara om nar texten andrats. Byter nagon annan (t.ex. omritning vid variantbyte)
   ut innehallet ar forsta barnet ett annat, och da skrivs texten alltid. */
/* INP (omgang 52): har texten samma uppbyggnad som forra gangen (samma taggar, bara nya
   siffror) skrivs bara textnoderna om. innerHTML tar bort och lagger till noder, och da
   raknar webblasaren om stilen for hela sidan (~100 ms pa mobil, matt); med sekunder i
   nedrakningen hande det varje sekund. Samma text och samma taggar som forut. */
var TPL = document.createElement('template');
function patch(el, html) {
 TPL.innerHTML = html;
 var pairs = [];
 var same = function (a, b) {
   if (a.childNodes.length !== b.childNodes.length) return false;
   for (var i = 0; i < a.childNodes.length; i++) {
     var x = a.childNodes[i], y = b.childNodes[i];
     if (x.nodeType !== y.nodeType) return false;
     if (x.nodeType === 3) { if (x.nodeValue !== y.nodeValue) pairs.push([x, y.nodeValue]); continue; }
     if (x.nodeType !== 1 || x.tagName !== y.tagName || x.attributes.length !== y.attributes.length) return false;
     for (var k = 0; k < y.attributes.length; k++) if (x.getAttribute(y.attributes[k].name) !== y.attributes[k].value) return false;
     if (!same(x, y)) return false;
   }
   return true;
 };
 if (!same(el, TPL.content)) return false;
 for (var j = 0; j < pairs.length; j++) pairs[j][0].nodeValue = pairs[j][1];
 return true;
}
function setHtml(el, html) {
 if (!el) return;
 if (el.__onHtml === html && el.__onFirst === el.firstChild && el.firstChild) return;
 if (el.__onHtml != null && el.__onFirst === el.firstChild && el.firstChild && patch(el, html)) { el.__onHtml = html; return; }
 el.innerHTML = html; el.__onHtml = html; el.__onFirst = el.firstChild;
}
class OnDeliveryTrust extends HTMLElement {
connectedCallback() {
 this.cc = (this.getAttribute('data-cc') || 'SE').toUpperCase();
 this.lang = this.getAttribute('data-lang') || 'en';
 this.days = parseInt(this.getAttribute('data-days') || '7', 10);
 this.flag = this.getAttribute('data-flag') || '';
 this.dstyle = this.getAttribute('data-style') || 'countdown';
 this.tmpl = this.getAttribute('data-tmpl') || '';
 this.loc = LOCMAP[this.lang] || 'en-GB';
 this.msgEl = this.querySelector('[data-ondb-msg]');
 this.initV3();
 this.update = this.update.bind(this);
 this.update();
 var tick = this.dstyle !== "order_now" || this.getAttribute("data-trust") === "v3";
 if (tick) this.timer = setInterval(this.update, 1000);
}
disconnectedCallback() { clearInterval(this.timer); }
 formatTime(h, m, s) {
 var unit = HLABEL[this.lang] || 'h';
 /* Varje siffra far en fast egen bredd. Enbart tabular-nums racker inte:
    faller typsnittet tillbaka, eller saknar den feta skaran tnum-tabellen,
    byter raden bredd varje sekund och texten runt omkring hoppar i sidled. */
 var digits = (pad(h) + ':' + pad(m) + ':' + pad(s)).replace(/\d/g, function (d) {
   return '<span class="on-db__d">' + d + '</span>';
 });
 return '<span class="on-db__timer">' + digits + ' ' + unit + '</span>';
}
bizAdd(d, n) {
 var r = new Date(d.getFullYear(), d.getMonth(), d.getDate());
 var added = 0;
 while (added < n) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) added++; }
 return r;
}
parts(date, tz) {
 try {
   var p = {}, arr = fmt(tz).formatToParts(date);
   arr.forEach(function (x) { p[x.type] = x.value; });
   var H = parseInt(p.hour, 10); if (H === 24) H = 0;
   return { Y:+p.year, M:+p.month, D:+p.day, h:H, mi:+p.minute, s:+p.second };
 } catch (e) {
   var n = new Date();
   return { Y:n.getFullYear(), M:n.getMonth()+1, D:n.getDate(), h:n.getHours(), mi:n.getMinutes(), s:n.getSeconds() };
 }
}
/* En enda mening, hamtad fardigoversatt ur snippeten on-deliv-phrase-i18n.
  [t] och [d] byts mot nedrakningen och datumet, bada feta som forut, och
  flaggan haktas pa sist. Ingen copy ligger kvar i skriptet. */
render(timeHtml, date) {
 var s = this.tmpl || 'Order within [t] for delivery [d]';
 if (timeHtml) s = s.split('[t]').join('<b>' + timeHtml + '</b>');
 s = s.split('[d]').join('<b>' + date + '</b>');
 if (this.flag) s += ' <span class="on-db__flag">' + this.flag + '</span>';
 return s;
}
 /* ---------------- v3 ----------------
  Copyn kommer fardigoversatt fran Liquid via data-attribut. Skriptet
  byter bara [t] och [d]. ?trust= tvingar en variant for forhandsgranskning. */
initV3() {
 try {
   var q = new URL(location.href).searchParams.get('trust');
   if (q === 'v1' || q === 'v3') this.setAttribute('data-trust', q);
 } catch (e) {}
 this.v3date = this.querySelector('[data-v3-date]');
 this.v3count = this.querySelector('[data-v3-count]');
 this.tHome = this.getAttribute('data-v3-home') || '';
 this.tShip = this.getAttribute('data-v3-ship') || '';
 this.tStock = this.getAttribute('data-v3-stock') || '';
 this.tTomorrow = this.getAttribute('data-v3-tomorrow') || '';
 this.tWeekday = this.getAttribute('data-v3-weekday') || '';
 this.cut = parseInt(this.getAttribute('data-cutoff') || '18', 10);
}
v3Time(total) {
 /* Timmarna kan bli fler an 24 nar nasta utskick ar efter en helg. Ingen
    dygnsenhet: "62h 10m" ar sprakneutralt och behover ingen oversattning. */
 var h = Math.floor(total / 3600), m = Math.floor((total % 3600) / 60), s = total % 60;
 var txt = h > 0 ? h + 'h ' + pad(m) + 'm' : pad(m) + 'm ' + pad(s) + 's';
 var digits = txt.replace(/\d/g, function (d) { return '<span class="on-db__d">' + d + '</span>'; });
 return '<span class="on-db__timer">' + digits + '</span>';
}
/* Allt raknas i BESOKARENS marknadstidszon. En svensk kund kl 22 ska se sin egen
  kvall, inte lagrets klocka. Cutoff-timmen galler lokalt pa varje marknad. */
updateV3() {
 if (!this.v3date) return;
 var tz = TZ[this.cc] || 'Europe/Stockholm';
 var p = this.parts(new Date(), tz);
 var secs = p.h * 3600 + p.mi * 60 + p.s;
 var today = new Date(p.Y, p.M - 1, p.D);
 var biz = function (d) { var w = d.getDay(); return w !== 0 && w !== 6; };
 var rem = this.cut * 3600 - secs;
 var soon = rem > 0 && biz(today);
 var days_off = 0;
 if (!soon) {
   /* Dagens avgang ar missad. Da raknar vi ner till MIDNATT, inte till nasta
      dags cutoff: klockan 22 sager "bestall inom 2h sa skickas den imorgon",
      inte "inom 19h". Midnatt ar ocksa den punkt dar texten byter till idag. */
   rem = 86400 - secs;
   var d = new Date(today.getTime());
   do { d.setDate(d.getDate() + 1); days_off++; } while (!biz(d));
 }
 var deliv = this.bizAdd(today, this.days + (soon ? 0 : 1));
 var dateStr = dstr(deliv, this.loc, { weekday: 'short', day: 'numeric', month: 'short' });
 setHtml(this.v3date, this.tHome.split('[d]').join('<b>' + dateStr + '</b>'));
 if (!this.v3count) return;
 /* Hinner den med idag sags det. Annars namns dagen den faktiskt gar: imorgon,
    eller veckodagen nar helgen ligger emellan. */
 var tmpl;
 if (soon) {
   tmpl = this.tShip;
 } else if (days_off === 1) {
   tmpl = this.tTomorrow;
 } else {
   var wd = new Date(today.getTime());
   wd.setDate(wd.getDate() + days_off);
   tmpl = this.tWeekday.split('[w]').join(this.weekdayName(wd));
 }
 setHtml(this.v3count, tmpl.split('[t]').join(this.v3Time(rem)));
}
/* Finskan boger veckodagen (maanantaina, inte maanantai) och det klarar inte
  toLocaleDateString. Ovriga sprak far den ur webblasaren. */
weekdayName(d) {
 if (this.lang === 'pt') {
   /* Portugisiskan sager segunda, inte segunda-feira, i vardagligt tal.
      Den langa formen spracker raden pa 360px. */
   return dstr(d, this.loc, { weekday: 'long' }).replace('-feira', '');
 }
 if (this.lang === 'fi') {
   return ['sunnuntaina','maanantaina','tiistaina','keskiviikkona','torstaina','perjantaina','lauantaina'][d.getDay()];
 }
 return dstr(d, this.loc, { weekday: 'long' });
}
update() {
 if (document.hidden) return;
 var tz = TZ[this.cc] || 'Europe/Stockholm';
 var p = this.parts(new Date(), tz);
 this.updateV3();
 if (!this.msgEl) return;
 var rem = (24 * 3600) - (p.h * 3600 + p.mi * 60 + p.s);
 if (rem < 0) rem = 0; if (rem > 24 * 3600) rem = 24 * 3600;
 var hh = Math.floor(rem / 3600), mm = Math.floor((rem % 3600) / 60), ss = rem % 60;
 var deliv = this.bizAdd(new Date(p.Y, p.M - 1, p.D), this.days);
 var dateStr = dstr(deliv, this.loc, { day:'numeric', month:'short' });
 if (this.dstyle === 'order_now') {
   setHtml(this.msgEl, this.render('', dateStr));
 } else {
   setHtml(this.msgEl, this.render(this.formatTime(hh, mm, ss), dateStr));
 }
}
}
customElements.define('on-delivery-trust', OnDeliveryTrust);
  })();

